// extracted by mini-css-extract-plugin
export default {"container":"ProjectPage_container__RhGSJ","title":"ProjectPage_title__-sb2W","content":"ProjectPage_content__zIpZH","subheader":"ProjectPage_subheader__atKup"};